// src/pages/NoWorkersPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Users, Home, Briefcase } from "lucide-react";

const NoWorkersPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-100 flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="bg-white/80 backdrop-blur-md rounded-2xl shadow-2xl p-10 max-w-lg w-full border border-gray-100"
      >
        <div className="flex flex-col items-center text-center space-y-6">
          <div className="bg-red-100 text-red-600 p-4 rounded-full">
            <Users className="w-10 h-10" />
          </div>

          <h1 className="text-3xl font-extrabold text-gray-800">
            No Approved Workers Found
          </h1>

          <p className="text-gray-600 leading-relaxed">
            We couldn’t find any{" "}
            <span className="font-semibold text-gray-800">approved workers</span> 
            in your area for this service right now.
          </p>

          <p className="text-gray-500 text-sm max-w-md">
            Your job has been automatically added to our{" "}
            <span className="font-semibold">priority waitlist</span>. 
            You’ll get an email notification the moment a verified worker becomes available.
          </p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="w-full space-y-3 mt-6"
          >
            <button
              onClick={() => navigate("/")}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-xl shadow-md hover:shadow-lg transition-all duration-200"
            >
              <Home className="w-5 h-5" />
              Go Back Home
            </button>

            <button
              onClick={() => navigate("/your-jobs")}
              className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-3 rounded-xl shadow-md hover:shadow-lg transition-all duration-200"
            >
              <Briefcase className="w-5 h-5" />
              View My Jobs
            </button>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default NoWorkersPage;
